<template>
  <div>
<h2 class="goth">Presens av starka verb</h2>

          <p class="grammatikparagrafbredd leftorient">Starka verb får i presens samma ändelser som svaga verb (<b>-e, -st, -t </b>eller<b> -en </b>),
              men de får nytt vokalljud i stammen <i>(omljud)</i> i 2:a och 3:e person i singular (<i>du</i> och <i>er, es, sie</i>). </p>
              <br>

        <p class="grammatikparagrafbredd leftorient"> Är vokalen <i>a</i> eller <i>au</i> får de "prickar" och blir <i>ä</i> eller<i> äu</i>.
        Kort <i>e</i> blir <i>i</i>, långt <i>e</i> blir <i>ie</i>.</p> <br>


<br>

        <div class="grammatikparagrafbredd leftorient">
<div class="understryk-rod">&nbsp;<i><b>a</b></i> blir <i><b>ä</b></i>&nbsp;</div>
        </div>

        <p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>fahren</i> (åka, köra)</p>



        <table class="">
    <br>

            <tr class="leftorient">
                <td class="ljusgra"><i>ich</i></td>
                <td class="ljusgra"><i>fahr<b>e</b></i></td>
            </tr>

            <tr class="leftorient">

                <td class="ljusgra"><i>du</i></td>
                <td class="ljusgra"><i>f<b><div class="accented">ä</div></b>hr<b>st</b></i></td>
            </tr>

            <tr class="leftorient">

                <td class="ljusgra"><i>er<br> es<br> sie</i></td>
                <td class="ljusgra"><i>f<b><div class="accented">ä</div></b>hr<b>t</b></i></td>
            </tr>

            <tr class="leftorient">

            </tr>


            <tr class="leftorient">
                <td class="upperspace ljusgra"><i>wir</i></td>
                <td class="ljusgra"><i>fahr<b>en</b></i></td>
            </tr>

            <tr class="leftorient">


                <td class="ljusgra"><i>ihr</i></td>
                <td class="ljusgra"><i>fahr<b>t</b></i></td>
            </tr>

            <tr class="leftorient">


                <td class="ljusgra"><i>sie<br> Sie</i></td>
                <td class="ljusgra"><i>fahr<b>en</b></i></td>
            </tr>


        </table>






<br>
<br>


<div class="grammatikparagrafbredd leftorient">
<div class="understryk-rod">&nbsp;<i><b>au</b></i> blir <i><b>äu</b></i>&nbsp;</div>
<div class="mindre inlajn">&nbsp;&nbsp;&nbsp;( äu uttalas [oj] )</div>
</div>

<p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>laufen</i> (springa, löpa)</p>



<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i>ich</i></td>
        <td class="ljusgra"><i>lauf<b>e</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>du</i></td>
        <td class="ljusgra"><i>l<b><div class="accented">äu</div></b>f<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>er<br> es<br> sie</i></td>
        <td class="ljusgra"><i>l<b><div class="accented">äu</div></b>f<b>t</b></i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace ljusgra"><i>wir</i></td>
        <td class="ljusgra"><i>lauf<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>ihr</i></td>
        <td class="ljusgra"><i>lauf<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>sie<br> Sie</i></td>
        <td class="ljusgra"><i>lauf<b>en</b></i></td>
    </tr>


</table>
<br><br>
<div class="grammatikparagrafbredd leftorient">
<div class="understryk-rod">&nbsp;kort <i><b>e</b></i> blir <i><b>i</b></i>&nbsp;</div>

</div>

<p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>sprechen</i> (prata)</p>



<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i>ich</i></td>
        <td class="ljusgra"><i>sprech<b>e</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>du</i></td>
        <td class="ljusgra"><i>spr<b><div class="accented">i</div></b>ch<b>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>er<br> es<br> sie</i></td>
        <td class="ljusgra"><i>spr<b><div class="accented">i</div></b>ch<b>t</b></i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace ljusgra"><i>wir</i></td>
        <td class="ljusgra"><i>sprech<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>ihr</i></td>
        <td class="ljusgra"><i>sprech<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>sie<br> Sie</i></td>
        <td class="ljusgra"><i>sprech<b>en</b></i></td>
    </tr>


</table>



<br><br>


<div class="grammatikparagrafbredd leftorient">
<div class="understryk-rod">&nbsp;långt <i><b>e</b></i> blir <i><b>ie</b></i>&nbsp;</div>

</div>

<p class="grammatikparagrafbredd leftorient">Exempel med verbet <i>lesen</i> (läsa)</p>



<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i>ich</i></td>
        <td class="ljusgra"><i>les<b>e</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>du</i></td>
        <td class="ljusgra"><i>l<b><div class="accented">ie</div>st</b></i></td>
    </tr>

    <tr class="leftorient">

        <td class="ljusgra"><i>er<br> es<br> sie</i></td>
        <td class="ljusgra"><i>l<b><div class="accented">ie</div>st</b></i></td>
    </tr>

    <tr class="leftorient">

    </tr>


    <tr class="leftorient">
        <td class="upperspace ljusgra"><i>wir</i></td>
        <td class="ljusgra"><i>les<b>en</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>ihr</i></td>
        <td class="ljusgra"><i>les<b>t</b></i></td>
    </tr>

    <tr class="leftorient">


        <td class="ljusgra"><i>sie<br> Sie</i></td>
        <td class="ljusgra"><i>les<b>en</b></i></td>
    </tr>


</table>


<br><br>


<br><br><br>



</div>

</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "presens starka verb"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
